import type { ContentPack } from '../engine/pack';

/** en-theme@1.0.0 — 관리자 콘솔이 발행했다. 손으로 고치면 packHash 가 바뀐다(patch bump). */
export const PACK_EN_THEME_1_0_0: ContentPack = {
  id: 'en-theme',
  version: '1.0.0',
  kind: 'inference',
  questions: [
    {
      id: 'c001',
      q: 'Which country?',
      a: 'PERU',
      d: ['B', 'C', 'F', 'V', 'D', 'O'],
      tags: ['en-country'],
      hints: ['Machu Picchu', 'Andes', 'llamas'],
    },
    {
      id: 'c002',
      q: 'Which country?',
      a: 'CUBA',
      d: ['E', 'V', 'D', 'O', 'W', 'P'],
      tags: ['en-country'],
      hints: ['Havana', 'Caribbean', 'salsa'],
    },
    {
      id: 'c003',
      q: 'Which country?',
      a: 'IRAN',
      d: ['L', 'F', 'C', 'M', 'J', 'K'],
      tags: ['en-country'],
      hints: ['Persia', 'Tehran', 'saffron'],
    },
    {
      id: 'c004',
      q: 'Which country?',
      a: 'MALI',
      d: ['N', 'C', 'H', 'E', 'J', 'W'],
      tags: ['en-country'],
      hints: ['Timbuktu', 'Sahara', 'Bamako'],
    },
    {
      id: 'c005',
      q: 'Which country?',
      a: 'CHILE',
      d: ['M', 'O', 'N', 'J', 'A', 'K'],
      tags: ['en-country'],
      hints: ['Atacama', 'Moai statues', 'Santiago'],
    },
    {
      id: 'c006',
      q: 'Which country?',
      a: 'SPAIN',
      d: ['Z', 'B', 'C', 'L', 'M', 'X'],
      tags: ['en-country'],
      hints: ['flamenco', 'Gaudi', 'siesta'],
    },
    {
      id: 'c007',
      q: 'Which country?',
      a: 'EGYPT',
      d: ['C', 'Q', 'U', 'B', 'I', 'O'],
      tags: ['en-country'],
      hints: ['pyramids', 'Nile', 'pharaohs'],
    },
    {
      id: 'c008',
      q: 'Which country?',
      a: 'KENYA',
      d: ['F', 'C', 'M', 'U', 'R', 'O'],
      tags: ['en-country'],
      hints: ['safari', 'Nairobi', 'marathoners'],
    },
    {
      id: 'c009',
      q: 'Which city?',
      a: 'ROME',
      d: ['F', 'C', 'N', 'K', 'H', 'P'],
      tags: ['en-city'],
      hints: ['Colosseum', 'Vatican', 'gelato'],
    },
    {
      id: 'c010',
      q: 'Which city?',
      a: 'LIMA',
      d: ['N', 'C', 'J', 'H', 'E', 'T'],
      tags: ['en-city'],
      hints: ['ceviche', 'Pacific', 'Pizarro'],
    },
    {
      id: 'c011',
      q: 'Which city?',
      a: 'DOHA',
      d: ['B', 'C', 'M', 'P', 'E', 'N'],
      tags: ['en-city'],
      hints: ['Qatar', 'Al Jazeera', 'Gulf pearls'],
    },
    {
      id: 'c012',
      q: 'Which city?',
      a: 'BERN',
      d: ['D', 'C', 'F', 'M', 'P', 'O'],
      tags: ['en-city'],
      hints: ['Switzerland', 'bears', 'Aare river'],
    },
    {
      id: 'c013',
      q: 'Which city?',
      a: 'PARIS',
      d: ['B', 'C', 'F', 'L', 'Z', 'D'],
      tags: ['en-city'],
      hints: ['Eiffel Tower', 'Louvre', 'Seine'],
    },
    {
      id: 'c014',
      q: 'Which city?',
      a: 'SEOUL',
      d: ['Z', 'C', 'V', 'I', 'X', 'W'],
      tags: ['en-city'],
      hints: ['Han river', 'K-pop', 'Gyeongbok'],
    },
    {
      id: 'c015',
      q: 'Which city?',
      a: 'CAIRO',
      d: ['E', 'L', 'F', 'J', 'K', 'T'],
      tags: ['en-city'],
      hints: ['Giza', 'Nile delta', 'Tahrir'],
    },
    {
      id: 'c016',
      q: 'Which city?',
      a: 'DUBAI',
      d: ['V', 'C', 'L', 'P', 'W', 'E'],
      tags: ['en-city'],
      hints: ['Burj Khalifa', 'desert malls', 'Palm island'],
    },
    {
      id: 'c017',
      q: 'Which food?',
      a: 'TACO',
      d: ['I', 'E', 'L', 'J', 'F', 'K'],
      tags: ['en-food'],
      hints: ['tortilla', 'salsa', 'Mexico'],
    },
    {
      id: 'c018',
      q: 'Which food?',
      a: 'TOFU',
      d: ['I', 'C', 'R', 'V', 'L', 'E'],
      tags: ['en-food'],
      hints: ['bean curd', 'soy', 'silken'],
    },
    {
      id: 'c019',
      q: 'Which food?',
      a: 'MISO',
      d: ['N', 'L', 'Z', 'C', 'H', 'J'],
      tags: ['en-food'],
      hints: ['soy paste', 'Japanese', 'soup base'],
    },
    {
      id: 'c020',
      q: 'Which food?',
      a: 'KALE',
      d: ['F', 'C', 'I', 'R', 'J', 'O'],
      tags: ['en-food'],
      hints: ['leafy green', 'smoothie', 'chips'],
    },
    {
      id: 'c021',
      q: 'Which food?',
      a: 'BAGEL',
      d: ['D', 'C', 'Q', 'I', 'P', 'Y'],
      tags: ['en-food'],
      hints: ['boiled ring', 'cream cheese', 'New York'],
    },
    {
      id: 'c022',
      q: 'Which food?',
      a: 'RAMEN',
      d: ['F', 'C', 'K', 'H', 'O', 'P'],
      tags: ['en-food'],
      hints: ['noodle broth', 'chashu', 'Japan'],
    },
    {
      id: 'c023',
      q: 'Which food?',
      a: 'PESTO',
      d: ['B', 'C', 'Z', 'I', 'D', 'X'],
      tags: ['en-food'],
      hints: ['basil sauce', 'pine nuts', 'Genoa'],
    },
    {
      id: 'c024',
      q: 'Which food?',
      a: 'MOCHI',
      d: ['N', 'E', 'L', 'J', 'W', 'A'],
      tags: ['en-food'],
      hints: ['rice cake', 'chewy', 'ice cream'],
    },
  ],
  locale: 'en',
};
